const translations = {

}

export const langKey = 'EN'

export default translations